module.exports = __webpack_public_path__ + "img/logo.9d0423e8.png";